import React, { useEffect, useRef } from "react";
import Dialog from "src/components/common/Dialog";

interface AreaProDialogProps {
  isOpen: boolean;
  onClose: () => void;
  insightsUrl: string | null;
  isLoading: boolean;
}

const AreaProDialog: React.FC<AreaProDialogProps> = ({
  isOpen,
  onClose,
  insightsUrl,
  isLoading,
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  // The embedded AreaPro app posts CLOSE_MODAL when its "Done" button is clicked
  useEffect(() => {
    if (!isOpen) return;

    const handleMessage = (event: MessageEvent<{ type?: string }>) => {
      if (event.source !== iframeRef.current?.contentWindow) return;
      if (event.data?.type === "CLOSE_MODAL") {
        onClose();
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [isOpen, onClose]);

  return (
    <Dialog
      isOpen={isOpen}
      onOpenChange={(open) => !open && onClose()}
      title=""
      className="area-pro-dialog !max-w-[1100px] !w-[95vw] md:!w-[1100px]"
    >
      <div className="w-full" style={{ height: "85vh" }}>
        {isLoading ? (
          <div className="w-full h-full flex items-center justify-center">
            <div className="text-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-4"></div>
              <p>Loading area insights...</p>
            </div>
          </div>
        ) : insightsUrl ? (
          <iframe
            ref={iframeRef}
            src={insightsUrl}
            className="w-full h-full border-0 rounded-lg"
            title="AreaPro Insights"
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <p className="text-gray-secondary">Unable to load area insights</p>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default AreaProDialog;
